import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';
import { useState } from 'react';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import BulkTempalte941 from '@/components/ui/BulkTempalte941';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const FicaTax = () => {
  const [isBulkUploadTemplate, setIsBulkUploadTemplate] = useState(false);
  return (
    <AppLayout
      meta={
        <Meta
          title="FICA Tax for 2026 | Social Security & Medicare Contributions"
          description="Understand FICA tax in 2026—who pays it, current rates, wage limits, exemptions, and how it impacts employee paychecks and self-employed individuals."
          keywords=""
          canonical="resources/employment-tax/fica-tax/"
          ogType="article"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
        />
      }
    >
      <BulkTempalte941
        isBulkUploadTemplate={isBulkUploadTemplate}
        setIsBulkUploadTemplate={setIsBulkUploadTemplate}
      />
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,

            mt: 3,
            textAlign: 'center',
          }}
        >
          Understanding the{' '}
          <span className="highlight-container">
            <span className="highlight">Federal Insurance</span>
          </span>{' '}
          <span className="highlight-container">
            <span className="highlight">Contributions Act</span>
          </span>
          (FICA)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
            textAlign: 'center',
          }}
        >
          Whether you are an employee, employer, or self-employed, it is
          important to understand the FICA tax.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          {/* <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=ficatax`}
          >
            E-File Now!
          </Button> */}
        </Box>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/employment-tax/fica-tax/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>

                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-06-15T09:00:00-05:00"
                      >
                        June 15, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-06-15T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        June 15, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>

                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    FICA Tax at a Glance
                  </Typography>
                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',

                      '& li': {
                        mb: 1.6,
                        position: 'relative',
                        pl: 3,
                      },

                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <b>FICA (Federal Insurance Contributions Act) tax</b>
                        {' is a federal payroll tax that funds '}
                        <b>Social Security and Medicare</b>. Both employers and
                        employees generally contribute to FICA taxes, while
                        self-employed individuals pay both portions through the
                        self-employment tax.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <b>Social Security Tax:</b>
                        {
                          ' 6.2% paid by the employee and 6.2% by the employer, up to the '
                        }
                        <b>$184,500 wage base for 2026</b>
                        {'. '}
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <b>Medicare Tax:</b>
                        {' 1.45% paid by both the employee and employer, with '}
                        <b>no wage limit</b>
                        {'. '}
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <b>Additional Medicare Tax:</b>
                        {' An '}
                        additional
                        {
                          " 0.9% may apply to employees' wages above the applicable threshold. "
                        }{' '}
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="5" />
                      <span itemProp="name">
                        <b>Reporting:</b>
                        {' Employers generally report FICA taxes on '}
                        <Link
                          href="https://www.taxzerone.com/resources/employment-tax/form-941-instructions/"
                          sx={{ color: '#0202ff' }}
                        >
                          <b>Form 941</b>
                        </Link>
                        {' and '}
                        <Link
                          href="https://www.taxzerone.com/resources/information-returns/form-w-2-instructions/"
                          sx={{ color: '#0202ff' }}
                        >
                          <b>Form W-2</b>
                        </Link>
                        {'. '}
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="6" />
                      <span itemProp="name">
                        <b>Exemptions:</b>
                        {
                          ' Certain workers, such as qualifying student workers, nonresident alien students, and some employees of religious organizations, may be exempt from FICA taxes. '
                        }
                      </span>
                    </li>
                  </Box>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If you are employed in the United States, you have probably
                  noticed FICA tax deductions on your paycheck. But do you know
                  what exactly FICA is, and why are these taxes withheld?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  In this guide, we will break down what FICA tax is, how much
                  you pay, who is responsible for paying it, and how it impacts
                  your future benefits.
                </Typography>
                <Box
                  sx={{
                    pt: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents </b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What is FICA tax?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whocan" sx={{ color: '#0202ff' }}>
                          Who pays FICA tax?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#type" sx={{ color: '#0202ff' }}>
                          Types of FICA Tax
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#social" sx={{ color: '#0202ff' }}>
                          Social Security Tax
                        </Link>
                        <List>
                          <ListItem sx={{ py: 0, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#wage" sx={{ color: '#0202ff' }}>
                                Wage Limit
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#tax" sx={{ color: '#0202ff' }}>
                          Medicare Tax
                        </Link>
                        <List>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#add" sx={{ color: '#0202ff' }}>
                                Additional Medicare Tax
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#limit" sx={{ color: '#0202ff' }}>
                                Wage Limit
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#rate" sx={{ color: '#0202ff' }}>
                          FICA Tax Rates for 2026
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#fica" sx={{ color: '#0202ff' }}>
                          How are the FICA taxes calculated?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#exempt" sx={{ color: '#0202ff' }}>
                          Exemptions from FICA Tax
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#report" sx={{ color: '#0202ff' }}>
                          Reporting FICA on Tax Forms
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Scenarios
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="whatis"
                >
                  What is FICA tax?
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  FICA (
                  <span style={{ fontWeight: 600 }}>
                    Federal Insurance Contributions Act
                  </span>
                  ) tax is an important U.S. federal payroll tax which is used
                  to fund the Social Security and Medicare programs. These
                  programs provide benefits to retirees, and disabled
                  individuals, as well as health coverage to individuals aged 65
                  and older.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="whocan"
                >
                  Who pays FICA tax?
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    FICA tax is contributed by both employers and employees
                    equally. Employee shares are automatically withheld from
                    their wages, and employer shares should match that
                    amount.{' '}
                  </li>
                  <li>
                    Self-employed individuals are responsible for covering both
                    the employee and employer shares of FICA taxes through the
                    Self-Employment Contributions Act (SECA) tax.{' '}
                  </li>
                  <li>
                    FICA tax applies to{' '}
                    <span style={{ fontWeight: 600 }}> household workers</span>{' '}
                    who are paid{' '}
                    <span style={{ fontWeight: 600 }}>$3,000 or more</span> in
                    cash wages in 2026.{' '}
                  </li>
                  <li>
                    FICA tax also applies to{' '}
                    <span style={{ fontWeight: 600 }}>election workers</span>{' '}
                    who earn{' '}
                    <span style={{ fontWeight: 600 }}>$2,500 or more</span> in
                    cash or equivalent compensation during the year 2026.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="type"
                >
                  Types of FICA Tax
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  There are two types of Federal Insurance Contributions Act
                  (FICA) taxes. They are
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Social Security tax </li>
                  <li>Medicare tax </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="social"
                >
                  Social Security Tax
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Social Security tax is used to fund the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Social Security program
                  </span>
                  , which provides retirement benefits, disability benefits, and
                  survivor benefits to eligible Americans. Here’s how it works:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Employees</span> pay{' '}
                    <span style={{ fontWeight: 600 }}>6.2%</span> of their wages
                    in Social Security tax.
                    <span style={{ fontWeight: 600 }}> Employers</span> also pay
                    an equal amount of{' '}
                    <span style={{ fontWeight: 600 }}>6.2%</span>. So, in total,
                    <span style={{ fontWeight: 600 }}> 12.4%</span> of your
                    wages go to Social Security.{' '}
                  </li>
                  <li>
                    For{' '}
                    <span style={{ fontWeight: 600 }}>
                      self-employed individuals
                    </span>
                    , they must pay the full{' '}
                    <span style={{ fontWeight: 600 }}>12.4%</span>&nbsp;as part
                    of the SECA tax.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 21, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 87,
                  }}
                  id="wage"
                >
                  Wage Limit:
                </Typography>

                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Social security tax only applies to the income of a certain
                    limit each year. This is known as the{' '}
                    <span style={{ fontWeight: 600 }}>
                      Social Security wage base
                    </span>
                    .
                  </li>
                  <li>
                    The wage base limit for the 2026 tax year is $184,500. Any
                    income above the limit is not subject to Social Security
                    tax.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="tax"
                >
                  Medicare Tax
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Medicare tax is used to fund the Medicare program, which
                  offers health insurance to people aged 65 and older, as well
                  as some younger individuals with disabilities. Here’s how it
                  works:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Employees</span> pay{' '}
                    <span style={{ fontWeight: 600 }}>1.45%</span> of their
                    wages in Medicare tax.{' '}
                    <span style={{ fontWeight: 600 }}>Employers</span> also pay{' '}
                    <span style={{ fontWeight: 600 }}>1.45%</span>. So, a total
                    of 2.9% will go to Medicare. .
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Self-employed individuals
                    </span>{' '}
                    must pay the full{' '}
                    <span style={{ fontWeight: 600 }}>2.9%</span> through the{' '}
                    <span style={{ fontWeight: 600 }}>SECA</span> tax.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 21, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 87,
                  }}
                  id="add"
                >
                  Additional Medicare Tax:
                </Typography>

                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Employees and self-employed individuals pay an{' '}
                    <span style={{ fontWeight: 600 }}>extra 0.9%</span> in
                    Medicare tax on income over:
                  </li>
                  <ul>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>$200,000</span> for
                      single filers{' '}
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>$250,000</span> for
                      married filing{' '}
                      <span style={{ fontWeight: 600 }}>jointly </span>
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>$125,000</span> for
                      married filing{' '}
                      <span style={{ fontWeight: 600 }}>separately </span>
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>$200,000</span> for for
                      Head of Household
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>$200,000</span> for
                      Qualifying widow(er) with dependent child
                    </li>
                  </ul>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 21, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 87,
                  }}
                  id="limit"
                >
                  Wage Limit:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  There is no wage limit. All earnings are subject to 1.45%
                  Medicare tax.{' '}
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="rate"
                >
                  FICA Tax Rates for 2026
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Tax Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Employee Rate
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Employer Rate
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Self-Employed Rate
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Social Security </TableCell>
                          <TableCell>6.2% </TableCell>
                          <TableCell>6.2% </TableCell>

                          <TableCell>12.4% </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Medicare </TableCell>
                          <TableCell>1.45% </TableCell>
                          <TableCell>1.45% </TableCell>
                          <TableCell>2.9% </TableCell>
                        </TableRow>
                        <TableRow sx={{ fontWeight: 600 }}>
                          <TableCell sx={{ fontWeight: 600 }}>Total </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>7.65% </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>7.65% </TableCell>

                          <TableCell sx={{ fontWeight: 600 }}>15.3% </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="fica"
                >
                  How are the FICA taxes calculated?
                </Typography>
                <Box
                  sx={{
                    mb: 2,
                    backgroundColor: '#dfe7fd',
                    p: 2,
                    borderRadius: 3,

                    border: '2px solid #3e66d4ff',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      mt: 1,
                      fontStyle: 'italic',
                      mb: 0.8,
                    }}
                  >
                    Example 1:
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Let us take your annual salary as $100,000.
                  </Typography>
                  <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                    <li>
                      {' '}
                      Social Security tax = Gross Earnings (up to $184,500) ×
                      6.2%{' '}
                    </li>
                    <li style={{ listStyleType: 'none', textAlign: 'center' }}>
                      {' '}
                      = $100,000 × 6.2% ={' '}
                      <span style={{ fontWeight: 600 }}>$6,200</span>{' '}
                    </li>
                    <li>
                      {' '}
                      Medicare tax = $100,000 × 1.45% ={' '}
                      <span style={{ fontWeight: 600 }}>$1,450</span>
                    </li>
                    <li>
                      {' '}
                      Total FICA withheld = $6,200 + $1,450 ={' '}
                      <span style={{ fontWeight: 600 }}>$7,650</span>{' '}
                    </li>
                  </Box>
                </Box>
                <Box
                  sx={{
                    mb: 2,
                    backgroundColor: '#dfe7fd',
                    p: 2,
                    borderRadius: 3,

                    border: '2px solid #3e66d4ff',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      mt: 1,
                      fontStyle: 'italic',
                      mb: 0.8,
                    }}
                  >
                    Example 2:
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Let us take your annual salary as $300,000 and you are a{' '}
                    <span style={{ fontWeight: 600 }}>single filer</span>.
                  </Typography>
                  <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                    <li>
                      {' '}
                      Social Security tax = Gross Earnings (up to $184,500) ×
                      6.2%
                    </li>
                    <li style={{ listStyleType: 'none', textAlign: 'center' }}>
                      {' '}
                      = $184,500 × 6.2% =
                      <span style={{ fontWeight: 600 }}>$11,439</span>{' '}
                    </li>
                    <li>
                      {' '}
                      Medicare tax = $300,000 × 1.45% ={' '}
                      <span style={{ fontWeight: 600 }}>$4,350 </span>
                    </li>
                    <li>
                      {' '}
                      Additional Medicare tax = $100,000 × 0.9% ={' '}
                      <span style={{ fontWeight: 600 }}>$900</span>{' '}
                    </li>
                    <li>
                      {' '}
                      Total FICA withheld = $11,439 + $4350 + $900 ={' '}
                      <span style={{ fontWeight: 600 }}>$16,689</span>{' '}
                    </li>
                  </Box>
                </Box>
                <Box
                  sx={{
                    mb: 2,
                    backgroundColor: '#dfe7fd',
                    p: 2,
                    borderRadius: 3,

                    border: '2px solid #3e66d4ff',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      mt: 1,
                      fontStyle: 'italic',
                      mb: 0.8,
                    }}
                  >
                    Example 3:
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Let us take your annual salary as $300,000 and you are a{' '}
                    <span style={{ fontWeight: 600 }}>joint filer</span>.
                  </Typography>
                  <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                    <li>
                      {' '}
                      Social Security tax = Gross Earnings (up to $184,500) ×
                      6.2%
                    </li>
                    <li style={{ listStyleType: 'none', textAlign: 'center' }}>
                      {' '}
                      = ($184,500) × 6.2% =
                      <span style={{ fontWeight: 600 }}>$11,439</span>{' '}
                    </li>
                    <li>
                      {' '}
                      Medicare tax = $300,000 × 1.45% ={' '}
                      <span style={{ fontWeight: 600 }}> $ 4,350 </span>
                    </li>
                    <li>
                      {' '}
                      Additional Medicare tax = $50,000 × 0.9% ={' '}
                      <span style={{ fontWeight: 600 }}>$450</span>{' '}
                    </li>
                    <li>
                      {' '}
                      Total FICA withheld = $11,439 + $4,350 + $450 ={' '}
                      <span style={{ fontWeight: 600 }}>$16,239</span>{' '}
                    </li>
                  </Box>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="exempt"
                >
                  Exemptions from FICA Tax
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  While most workers must pay FICA taxes, there are a few
                  specific exemptions granted under federal law.{' '}
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Category
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            FICA Exempt
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Conditions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Religious group members </TableCell>
                          <TableCell>Yes </TableCell>

                          <TableCell>
                            Must file Form 4029 and meet strict criteria{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Nonresident alien students </TableCell>
                          <TableCell>Yes </TableCell>

                          <TableCell>
                            Must be eligible for a visa (F-1, J-1, or M-1){' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Children working for parents </TableCell>
                          <TableCell>Yes </TableCell>

                          <TableCell>
                            Applies to sole proprietorships{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Student workers </TableCell>
                          <TableCell> Sometimes </TableCell>

                          <TableCell>
                            Must be enrolled and working for the school{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>State/local government workers </TableCell>
                          <TableCell>Sometimes </TableCell>

                          <TableCell>
                            Covered by alternative retirement plan{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 87,
                  }}
                  id="report"
                >
                  Reporting FICA on Tax Forms
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Employers report FICA taxes on:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    {' '}
                    <Link
                      href="/resources/employment-tax/form-941-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 941
                    </Link>
                    : Employer’s Quarterly Federal Tax Return{' '}
                  </li>
                  <li>
                    <Link
                      href="/resources/information-returns/form-w-2-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form W-2
                    </Link>
                    : Annual wage and tax statement for employees{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Form 1040 (Schedule SE)
                    </span>
                    : For self-employed individuals{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 87,
                  }}
                  id="common"
                >
                  Common Scenarios:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  1. What does FICA stand for?
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  FICA stands for Federal Insurance Contributions Act. It refers
                  to the U.S. federal payroll tax that is used to fund Social
                  Security and Medicare programs.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  2. Is FICA tax refundable?
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  No, it is not refundable. However, overpayments (e.g.,
                  multiple employers withholding above the wage limit) may be
                  refundable when filing your tax return.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  3. Do retirees pay FICA tax?
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Retirees don&apos;t pay FICA tax on retirement income, but if
                  they earn wages from a job, they are required to pay FICA tax
                  on those earnings.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    lineHeight: 1.5,
                  }}
                >
                  4. What happens if FICA tax isn&apos;t withheld properly?
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If FICA tax isn&apos;t withheld correctly, the employer may
                  have to pay both the employer and employee portions, along
                  with penalties and interest. The employee could also lose
                  Social Security and Medicare credits, which may affect future
                  benefits.
                </Typography>

                <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                  <Accordion
                    // defaultExpanded
                    sx={{
                      '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                        {
                          background: 'none !important',
                        },
                      '&.MuiAccordion-root': { background: 'none !important' },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls=""
                      id=""
                      sx={{
                        px: 0,
                        m: 0,
                        justifyContent: 'flex-start',
                        '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                          { m: '0 !important', flexGrow: 0 },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          color: '#014361',
                          fontSize: 16,
                        }}
                      >
                        Sources and References
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{ mt: 1 }}
                      >
                        The information provided is based on guidelines from the
                        IRS website. For more information, check the{' '}
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/p15.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          2025 Publication 15
                        </Link>{' '}
                        and{' '}
                        <Link
                          href="https://www.irs.gov/taxtopics/tc751"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          TC751
                        </Link>
                        .{' '}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Alert>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready for payroll tax filing?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              Stay ahead of your payroll responsibilities with TaxZerone. Our
              smart system will{' '}
              <Hidden smDown>
                {' '}
                <br />
              </Hidden>
              auto calculate your taxes. So, you can file with confidence and
              stay compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=ficatax`}
              >
                E-File Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default FicaTax;
